import type { CharacterId } from './config'
export const SKINS = [
  { id:'original', character:'all', name:'原装出厂', detail:'原始角色 · 完整逐帧动作', price:0, image:null, atlas:null as string|null, source:null },
  { id:'cow-qing', character:'cow', name:'牛鼎记', detail:'圆墨镜 · 官服补子 · 朝珠', price:2000, image:'/assets/skins/cow-qing.png', atlas:null as string|null, source:'https://finance.sina.com.cn/roll/2026-08-17/doc-ininrkkn9073198.shtml' },
  { id:'frog-nezha', character:'frog', name:'哪吒奶蛙', detail:'双丸子头 · 红马甲 · 金项圈', price:2000, image:'/assets/skins/frog-nezha.png', atlas:null as string|null, source:'https://github.com/Nailong-Studio/wallpaper/blob/main/laugh-gallery/%E5%A5%B6%E8%9B%99-%E5%93%AA%E5%90%92.png' },
  { id:'mouse-lace', character:'mouse', name:'蕾丝嘟嘟', detail:'蝴蝶结头盔 · 蕾丝眼罩 · 蓬裙', price:2000, image:'/assets/skins/mouse-lace.png', atlas:null as string|null, source:'https://feidudu.org/stickers/39_lace.jpg' },
] as const
export type SkinId = typeof SKINS[number]['id']
// Consolidate retired variants into one complete costume per character.
const oldSlots=[
 {id:'cow-qing',low:['cow-concrete','cow-hero'],high:['cow-mold','cow-qing']},
 {id:'frog-nezha',low:['frog-berry','frog-nezha'],high:['frog-night','frog-kimono']},
 {id:'mouse-lace',low:['mouse-ice','mouse-naruto'],high:['mouse-toxic','mouse-lace']},
] as const
const legacySkins:Record<string,SkinId>={}
for(const slot of oldSlots)for(const id of [...slot.low,...slot.high])legacySkins[id]=slot.id
const migrateSkin=(id:unknown):unknown=>typeof id==='string'?(legacySkins[id]??id):id
interface Progress { wardrobeRevision:2;coins:number; earned:number; owned:SkinId[]; equipped:Record<CharacterId,SkinId> }
interface StorageLike { getItem(key:string):string|null;setItem(key:string,value:string):void }
const KEY='three-phantoms-progress-v1'
const fresh=():Progress=>({wardrobeRevision:2,coins:0,earned:0,owned:['original'],equipped:{cow:'original',frog:'original',mouse:'original'}})
const validNumber=(n:unknown)=>typeof n==='number'&&Number.isSafeInteger(n)&&n>=0&&n<=100000000
export function skinFor(id:string) { return SKINS.find(s=>s.id===id)??SKINS[0] }
export class ProgressStore {
  data:Progress=fresh(); persistent=true;refundedCoins=0
  constructor(private storage?:StorageLike) {
    if(!storage){this.persistent=false;return}
    try {
      const raw=storage.getItem(KEY);if(!raw)return
      const p=JSON.parse(raw);if(!p || !validNumber(p.coins))return
      this.data.coins=p.coins;this.data.earned=validNumber(p.earned)?p.earned:p.coins
      const rawOwned:unknown[]=Array.isArray(p.owned)?p.owned:[]
      const owned=rawOwned.map(migrateSkin)
      if(p.wardrobeRevision!==2){
        for(const slot of oldSlots){
          const paid=(slot.low.some(id=>rawOwned.includes(id))?40:0)+(slot.high.some(id=>rawOwned.includes(id))?100:0)
          if(paid)this.refundedCoins+=Math.max(0,paid-40)
        }
        this.data.coins=Math.min(100000000,this.data.coins+this.refundedCoins)
      }
      this.data.owned=['original',...SKINS.filter(s=>s.id!=='original'&&owned.includes(s.id)).map(s=>s.id)]
      for(const c of ['cow','frog','mouse'] as CharacterId[]) {
        const id=migrateSkin(p.equipped?.[c]);const skin=skinFor(typeof id==='string'?id:'original')
        if(this.data.owned.includes(skin.id)&&(skin.character==='all'||skin.character===c))this.data.equipped[c]=skin.id
      }
      if(p.wardrobeRevision!==2)this.save()
    } catch { /* Invalid local data uses the original skin and zero balance. */ }
  }
  private save() {
    try {if(!this.storage)throw new Error('Storage unavailable');this.storage.setItem(KEY,JSON.stringify(this.data));this.persistent=true}
    catch {this.persistent=false}
  }
  earn(amount:number) {
    if(!Number.isSafeInteger(amount)||amount<=0)return
    this.data.coins=Math.min(100000000,this.data.coins+amount);this.data.earned=Math.min(100000000,this.data.earned+amount);this.save()
  }
  equip(character:CharacterId,id:SkinId) {
    const skin=skinFor(id)
    if(skin.id!==id||(skin.character!=='all'&&skin.character!==character))return false
    if(!this.data.owned.includes(id)) {
      if(this.data.coins<skin.price)return false
      this.data.coins-=skin.price;this.data.owned.push(id)
    }
    this.data.equipped[character]=id;this.save();return true
  }
}
